var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08669 1.16699H2.19919C1.62895 1.16699 1.16669 1.62926 1.16669 2.19949V5.08699C1.16669 5.65723 1.62895 6.11949 2.19919 6.11949H5.08669C5.65692 6.11949 6.11919 5.65723 6.11919 5.08699V2.19949C6.11919 1.62926 5.65692 1.16699 5.08669 1.16699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8009 1.16699H8.91336C8.34313 1.16699 7.88086 1.62926 7.88086 2.19949V5.08699C7.88086 5.65723 8.34313 6.11949 8.91336 6.11949H11.8009C12.3711 6.11949 12.8334 5.65723 12.8334 5.08699V2.19949C12.8334 1.62926 12.3711 1.16699 11.8009 1.16699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.795 7.875H8.9075C8.33727 7.875 7.875 8.33727 7.875 8.9075V11.795C7.875 12.3652 8.33727 12.8275 8.9075 12.8275H11.795C12.3652 12.8275 12.8275 12.3652 12.8275 11.795V8.9075C12.8275 8.33727 12.3652 7.875 11.795 7.875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08669 7.875H2.19919C1.62895 7.875 1.16669 8.33727 1.16669 8.9075V11.795C1.16669 12.3652 1.62895 12.8275 2.19919 12.8275H5.08669C5.65692 12.8275 6.11919 12.3652 6.11919 11.795V8.9075C6.11919 8.33727 5.65692 7.875 5.08669 7.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario);
export default __webpack_public_path__ + "static/media/scenario.8dfeee1ebde912a8b7bbc9cccd30525b.svg";
export { ForwardRef as ReactComponent };